module.exports = __webpack_public_path__ + "static/media/coming-soon.51060dcc.jpg";